import v3ApiClient from "./client";

const MASTER_DATA_BASE_PATH = "/v3/master-data";
const SCHEDULE_DRAFT_REFERENCE_BASE_PATH = "/v3/schedule/drafts/reference";

export const airportApi = {
    getAirportList: (params = {}) => v3ApiClient.get(`${SCHEDULE_DRAFT_REFERENCE_BASE_PATH}/airports`, { params }),
};

export const measurementUnitApi = {
    listUnits: (params = {}) => v3ApiClient.get(`${MASTER_DATA_BASE_PATH}/units`, { params }),
    getUnit: (unitId) => v3ApiClient.get(`${MASTER_DATA_BASE_PATH}/units/${unitId}`),
    createUnit: (payload) => v3ApiClient.post(`${MASTER_DATA_BASE_PATH}/units`, payload),
    updateUnit: ({ id, data }) => v3ApiClient.put(`${MASTER_DATA_BASE_PATH}/units/${id}`, data),
    deleteUnit: (unitId) => v3ApiClient.delete(`${MASTER_DATA_BASE_PATH}/units/${unitId}`),
};

export default {
    airport: airportApi,
    measurementUnit: measurementUnitApi,
};
